import React, { useEffect, useState } from 'react';
import styles from './KnowledgeBase.module.scss';
import TableComponent from '../../../component/molecules/Table/TableComponent';
import { knowledgeBase } from 'hooks/endpoints';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from 'component/layout/header/Header';
import CreateFolder from './factory/forms/create-folder/CreateFolderForm';
import AddDataSource from './factory/forms/add-data-source/AddDataSourceForm';
import { headerData } from './data/HeaderData';
import { usePost } from 'hooks/usePost';
import { knowledgeBaseToast } from 'helpers/toastMessages';
import { useToast } from 'app-context/toasterContext/ToastContext';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
import { useUserContext } from 'app-context/user/UserContext';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import MoreButton from 'component/atom/moreButton/MoreButton';
import PopOver from 'component/atom/moreButton/popOver/PopOver';

const KnowledgeBase = () => {
  const { selectedBot } = useUserContext();
  const toast = useToast();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const folderName = location.state?.folderName || null;
  const { showModal } = useTour();

  const [isCreateFolder, setsCreateFolder] = useState(false);
  const [isDataSource, setIsDataSource] = useState(false);

  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const handleOpenAddDataSource = () => {
      setIsDataSource(true);
    };

    window.addEventListener('openAddDataSource', handleOpenAddDataSource);

    return () => {
      window.removeEventListener('openAddDataSource', handleOpenAddDataSource);
    };
  }, []);

  const { mutate: getMaterial, isPending: isMaterialPending } = usePost({
    onSuccessToast: 'File fetched successfully!',
    toastType: 'add',
  });
  const { mutate: refreshIndexer, isPending: isIndexing } = usePost({
    onSuccessToast: 'Index refreshed successfully!',
    toastType: 'add',
  });
  const handleFileClick = (item) => {
    toast.open('Fetching file, please wait...', 'add');
    getMaterial(
      {
        url: knowledgeBase.getMaterial(item.companyMaterialId),
      },
      {
        onSuccess: (res) => {
          const fileUrl = res.data;

          window.open(fileUrl, '_blank');
        },
        onError: (error) => {
          console.error('Error fetching file:', error);
        },
      }
    );
  };

  const handleRefreshIndexers = () => {
    refreshIndexer(
      {
        url: knowledgeBase.refreshIndexers,
      },
      {
        onSuccess: () => {
          setRefetch((prev) => !prev);
        },
        onError: (error) => {
          console.error('Error refreshing indexers:', error);
        },
      }
    );
  };

  useEffect(() => {
    setRefetch((prev) => !prev);
  }, [id]);

  const filterButtons = id
    ? [
        {
          type: 'button',
          label: 'Add Data Source',
          func: () => setIsDataSource(true),
        },
      ]
    : [
        // {
        //   type: "button",
        //   label: "Set Refresh Rate",
        //   func: () => setModalOpen(true),
        // },
        // {
        //   type: 'button',
        //   label: 'Refresh Now',
        //   isLoading: isIndexing,
        //   variant: 'light',
        //   func: handleRefreshIndexers,
        // },
        {
          type: 'button',
          label: 'Create Folder',
          variant: 'light',
          func: () => setsCreateFolder(true),
        },
        {
          type: 'plus',
          label: 'Add Data Source',
          func: () => setIsDataSource(true),
        },
      ];

  const popOverItems = [
    {
      title: 'Refresh Now',
      handleFunction: () => {},
      icon: 'refetchSvg',
    },
    {
      title: 'Update Refresh Rate',
      handleFunction: () => {},
      icon: 'refetchSvg',
    },
    {
      title: 'Delete',
      handleFunction: () => {},
      icon: 'delete_table',
      color: 'red',
    },
  ];

  const renderMoreButton = (item) => {
    if (!item?.item?.isURL) {
      return;
    }
    return (
      <MoreButton icon='three_dots' toolTipText='More'>
        <PopOver stop info={popOverItems} />
      </MoreButton>
    );
  };

  return (
    <div key={id}>
      {isIndexing && toast.open(knowledgeBaseToast.refreshIndexer, 'update')}
      <Header
        title='Knowledge Base'
        isBack={!!id}
        subTitle={id ? `/ ${folderName ?? ''}` : null}
        containerClassname={styles.header}
      />
      <TableComponent
        rowKey='companyMaterialId'
        api={{
          get: {
            url: id
              ? knowledgeBase?.getKnowledgeBaseId
              : knowledgeBase?.getKnowledgeBase,
            queryKey: 'knowledge-base',
            params: id
              ? { botId: selectedBot?.botId, folderId: id }
              : { botId: selectedBot?.botId },
            refetchInterval: 600000,
          },
          delete: {
            url: knowledgeBase.delete,
            fileUrl: knowledgeBase.deleteFile,
          },
        }}
        actions={{
          onRowClick: {
            hasRowClick: true,
            func: (item) => {
              if (item.isFolder) {
                navigate(`/knowledge-base/${item.companyMaterialId}`, {
                  state: { folderName: item.folderName },
                });
              } else {
                handleFileClick(item);
              }
            },
          },
        }}
        isRefetch={refetch}
        headerData={headerData}
        filterButtons={filterButtons}
        isKnowledgeBase
        tableContainerClassName={styles['knowledge-table']}
        renderAdditionalComponent={renderMoreButton}
      />

      {isCreateFolder && (
        <CreateFolder
          isOpen={isCreateFolder}
          onClose={() => setsCreateFolder(false)}
          setRefetch={() => setRefetch((prev) => !prev)}
        />
      )}

      {isDataSource && (
        <AddDataSource
          isOpen={isDataSource}
          onClose={() => setIsDataSource(false)}
          setRefetch={() => setRefetch((prev) => !prev)}
          folderId={id}
        />
      )}
      {showModal && <TourModal />}
    </div>
  );
};

export default KnowledgeBase;
